document.addEventListener("DOMContentLoaded", function () {
  // Theme toggle
  (function () {
    var DOC = document.documentElement;
    var btnToggles = document.querySelectorAll(".theme-toggle");

    function apply(mode) {
      var isDark =
        mode === "dark" ||
        (mode === "system" &&
          window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches);

      DOC.setAttribute("data-theme-mode", mode);
      DOC.setAttribute("data-theme", isDark ? "dark" : "light");
      DOC.style.colorScheme = isDark ? "dark" : "light";
    }

    function getChoice() {
      return localStorage.getItem("themeMode");
    }

    function setChoice(mode) {
      localStorage.setItem("themeMode", mode);
      apply(mode);
    }

    (function init() {
      var choice = getChoice();
      if (!choice) {
        localStorage.setItem("themeMode", "system");
        choice = "system";
      }
      apply(choice);
    })();

    var media =
      window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
    if (media && media.addEventListener) {
      media.addEventListener("change", function () {
        if (getChoice() === "system") apply("system");
      });
    }

    if (btnToggles) {
      btnToggles.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var next = { light: "dark", dark: "system", system: "light" }[
            getChoice() || "system"
          ];
          setChoice(next);
        });
      });
    }
  })();

  // Article share copy to clipboard
  document.querySelectorAll(".article-share-copy").forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      navigator.clipboard.writeText(this.href);
      const tooltip = document.createElement("span");
      tooltip.classList.add("article-share-copy-tooltip");
      tooltip.textContent = "Lien copié!";

      this.style.position = "relative";
      this.appendChild(tooltip);

      setTimeout(() => {
        tooltip.style.opacity = "0";
        setTimeout(() => tooltip.remove(), 400);
      }, 2000);
    });
  });
});
